import React, { useEffect, useState } from "react";
import "../home/HomePage.scss";
import { Modal, Layout, Card } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "./MapView.scss";
import { getRequest } from "../../api/http";
import userapiservice from "../../api/userapiservice";
import MapComponent from "./MapComponent";
import ytPlayBtn from "../../assets/newImages/Play.svg";
import SynthesiaImage from '../../assets/newImages/synthesia.jpg'
import { motion } from "framer-motion";
import ModalPlayer from "../../components/PlayerModal/playerModal";
import ToastComponent from "../../components/ToastCompoent/ToastComponent";
import { useSelector, useDispatch } from "react-redux";
import { setPage, setMicroSiteName } from "../../Reducer/localStorageSlice";
import { getYouTubeVideoId } from "../../utils/helper";
import usePartnerName from "../../hooks/usePartnerName";

export default function MapView({
  orgDirectoryData,
  microSitesData,
  radius,
  selectedData,
  cardData,
  previewCardState,
  allowSetView = false,
  disableSetView,
  businessCardHeight,
  focusResults = false,
  viewportBounds = null,
  onViewportChange,
  onViewportFitted,
  onOrganisationListReset,
  mapSearchQuery = "",
  onMapSearchQueryChange,
  onMapSearchCleared,
  isMapVisible = true,
  focusRequest = null,
}) {
  const dispatch = useDispatch()

  const localData = useSelector((state) => state?.localStorage)
  const { formattedName: partner } = usePartnerName()
  const { zoom, partnerId, sector: sectorId } = localData

  const zoomValue = localStorage?.getItem('zoom') || zoom

  const [mapData, setMapData] = useState(microSitesData);
  const [radiusValue, setRadiusValue] = useState(zoomValue);
  const [cancelClick, setCancelClick] = useState(false)

  const [subSectors, setSubSectors] = useState([]);
  useEffect(() => {
    setRadiusValue(radius);
  }, [radius]);

  const [videoUrl, setVideoUrl] = useState("");
  const [mediatype, setmediatype] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [getSector, setGetSector] = useState([]);
  const [selectedMicrosite, setSelectedMicrosite] = useState(cardData);
  const [cardState, setCardState] = useState(previewCardState);
  const [currentBusinessCardPos, setCurrentBusinessCardPos] = useState({})
  const [clicked, setClicked] = useState("");

  useEffect(() => {
    setMapData(microSitesData);
  }, [microSitesData]);

  useEffect(() => {
    if (!focusRequest?.token || !focusRequest?.microsite) return;
    setSelectedMicrosite(focusRequest.microsite);
    setCardState(true);
    setCurrentBusinessCardPos((position) =>
      Number.isFinite(position?.y) ? position : { x: 0, y: 120 },
    );
  }, [focusRequest]);

  const [, setPartnerData] = useState({});

  const getPartnerDetails = async () => {
    if(!partner) return
    try {
      const response = await getRequest(
        userapiservice.getPartnerDetails(partner)
      );
      if (response) {
        setPartnerData(response);
      }
    } catch (e) {
      Modal.error({
        title: "Error",
        content: e.response?.data?.message || "Something went wrong...",
      });
    }
  };

  useEffect(() => {
    getPartnerDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partner]);
  useEffect(() => {
    if (clicked === "clicked") {
      setClicked("");
    }
  }, [clicked]);

  const { Content } = Layout;
  const navigate = useNavigate();
  const [, setSelectedZoom] = useState();
  const ChangeRadiusHandler = (value) => {
    !(clicked === "clicked") && setSelectedZoom();
  };

  const fetchSectorList = async () => {
    if (!partnerId) return; // ✅ Run only if partnerId exists
    try {
      const response = await getRequest(
        userapiservice.getAllSectors(partnerId)
      );
      setGetSector(response);
    } catch (error) { }
  };

  useEffect(() => {
    if (partner && partnerId) {
      fetchSectorList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partnerId]);

  const FindSectorName = (id) => {
    let response = "";
    getSector.forEach((data) => {
      if (id === data.id) {
        response = data.name;
      }
    });
    return response;
  };

  const getSubSector = async (sectorId) => {
    if (!sectorId) return; //
    try {

      const response = await getRequest(userapiservice.getSubSectors(sectorId));

      setSubSectors(response);
    } catch (error) {
      toast.error(<ToastComponent type={'Error'} message={error?.error || error?.message || 'Sorry, Something went wrong'} />)
    }
  };

  const FindSubSectorName = (id) => {
    let response = "";
    subSectors.forEach((data) => {
      if (id === data.id) {
        response = data.name;
      }
    });
    return response;
  };

  const selectedOrg = (data, state, businessCardPos) => {
    setCardState(state);
    setSelectedMicrosite(data);
    selectedData(data);
    setCurrentBusinessCardPos(businessCardPos);
  };

  const OnCardClickHandler = async (id, logo, name) => {
    if (!name) return;
    const formattedName = name.replace(/ /g, "_");
    dispatch(setMicroSiteName(formattedName))
    navigate(`/microsite/${formattedName}`, {
      state: { page: "map", logo: { logo } },
    });
  };

  const PlayVideoHandler = (url, mediaType) => {
    setmediatype(mediaType);
    setVideoUrl(url);
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setVideoUrl("");
  };

  useEffect(() => {
    FindSectorName();
    FindSubSectorName();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (sectorId) {
      getSubSector(sectorId);
    }
    dispatch(setPage('view'))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sectorId]);

  const extractSynthesiaId = (url) => {
    const match = url.match(/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/);
    return match ? match[0] : null;
  };

  const renderMapAdvertMedia = (item) => {
    if (
      item?.carouselLink?.mediaType === "SOCIAL_MEDIA" &&
      item?.carouselLink?.url
    ) {
      const videoID = getYouTubeVideoId(item.carouselLink?.url);
      if (!videoID) return null;
      return (
        <div className="media youtube" style={{ objectFit: "contain" }}>
          <img
            src={`https://img.youtube.com/vi/${videoID}/hqdefault.jpg`}
            alt="video "
            className="video-preview-image"
          />
          <img
            alt="play button"
            className="ytBtnOverlay"
            src={ytPlayBtn}
            onClick={(e) => {
              e.stopPropagation();
              PlayVideoHandler(
                `https://www.youtube.com/embed/${videoID}?autoplay=1&rel=0`,
                item?.carouselLink?.mediaType
              );
            }}
          />
        </div>
      );
    }

    if (
      item?.carouselLink?.mediaType === "VIMEO_MEDIA" &&
      item?.carouselLink?.url
    ) {
      return (
        <div
          className="media vimeo youtube"
          onClick={(e) => {
            e.stopPropagation();
            PlayVideoHandler(
              item?.carouselLink?.url,
              item?.carouselLink?.mediaType
            );
          }}
        >
          <img
            alt="Vimeo preview"
            src={`https://vumbnail.com/${item?.carouselLink?.url?.split("/")[4]}.jpg`}
            className="video-preview-image"
          />
          <img className="ytBtnOverlay" src={ytPlayBtn} alt="" />
        </div>
      );
    }

    if (
      item?.carouselLink?.mediaType === "SYNTHESIA_MEDIA" &&
      item?.carouselLink?.url
    ) {
      const videoId = extractSynthesiaId(item.carouselLink.url);
      if (!videoId) return null;
      return (
        <div
          className="media youtube"
          style={{ objectFit: "contain" }}
          onClick={(e) => {
            e.stopPropagation();
            PlayVideoHandler(
              `https://share.synthesia.io/embeds/videos/${videoId}?autoplay=1`,
              item.carouselLink.mediaType
            );
          }}
        >
          <img
            src={item?.carouselLink?.thumbnailUrl || SynthesiaImage}
            alt="Synthesia Video"
            className="video-preview-image"
          />
          <img className="ytBtnOverlay" src={ytPlayBtn} alt="Play Button" />
        </div>
      );
    }

    return (
      <div className="media">
        <div className="slider-Img">
          <img
            src={item?.carouselLink?.url}
            alt=""
            className="home-preview-img"
          />
        </div>
      </div>
    );
  };

  // CREATE PROFILE CODE

  if (mapData) {
    return (
      <Layout className="layout">
        <Content>
          {/* {mapData && ( */}
            <div className="map-container">
              <MapComponent
                disableSetView={disableSetView}
                radiusValue={radiusValue}
                ChangeRadiusHandler={ChangeRadiusHandler}
                markerData={mapData ?? []}
                orgDirectoryData = {orgDirectoryData}
                selectedOrg={selectedOrg}
                activeMiniPopup={selectedMicrosite}
                allowSetView={allowSetView}
                focusResults={focusResults}
                viewportBounds={viewportBounds}
                onViewportChange={onViewportChange}
                onViewportFitted={onViewportFitted}
                onOrganisationListReset={onOrganisationListReset}
                mapSearchQuery={mapSearchQuery}
                onMapSearchQueryChange={onMapSearchQueryChange}
                onMapSearchCleared={onMapSearchCleared}
                isMapVisible={isMapVisible}
                focusRequest={focusRequest}
                cancelClick={cancelClick}
                updateCancelClick={() => { setCancelClick(false) }}
              />
            </div>
          {/* )} */}

          {/* Floating card component */}
          <motion.div
            className="card-container-view"
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{
              duration: 0.8,
              delay: 0.5,
              ease: [0, 0.71, 0.2, 1.01],
            }}
          >
            {selectedMicrosite && cardState ? (
              // <div style={{top:currentBusinessCardPos?.y >=businessCardHeight ? `${currentBusinessCardPos?.y - businessCardHeight }px`  :  `${currentBusinessCardPos?.y+20}px` || '50%'}} className="previewCard">
              <div style={{ top: currentBusinessCardPos?.y >= businessCardHeight ? `${businessCardHeight / 2 + 20}px` : `${currentBusinessCardPos?.y + 20}px` || '50%' }} className={`previewCard ${selectedMicrosite?.isCluster ? 'previewCardCluster' : ''}`}
                onClick={() => {
                  if (selectedMicrosite?.isCluster || !selectedMicrosite?.isActual) {
                    return
                  }
                  OnCardClickHandler(
                    selectedMicrosite?.id,
                    selectedMicrosite?.micrositeLogo,
                    selectedMicrosite?.name
                  );
                }}
              >
                <Card
                  className={`card-item home-page-card-item card-hover map-card ${selectedMicrosite?.isCluster ? 'overflow-y' : ''}`}
                  bordered={false}
                  id={!selectedMicrosite?.isActual && !selectedMicrosite?.isCluster ? 'orgDirData' : ''}
                >
                  {selectedMicrosite?.isCluster && (
                    <div className="cluster-list-container">
                      {selectedMicrosite?.list?.length>=2 && <div className="cluster-list-header">
                        <div>{selectedMicrosite?.list?.length} businesses located here</div>
                        <CloseOutlined onClick={(e)=>{
                          e.stopPropagation()
                          setCardState(false);
                          setSelectedMicrosite({ closePopup: true });
                          selectedData({});
                          setCancelClick(true)
                        }} />
                        </div>}
                      {["Apps", "Directory"].map((section) => {
                        const items = (selectedMicrosite?.list || []).filter((item) =>
                          section === "Apps" ? item?.isActual : !item?.isActual
                        );
                        if (!items.length) return null;
                        return (
                          <div key={section} className="cluster-section">
                            {/* <div className="cluster-section-title">{section}</div> */}
                            {items.map((item, index) => {
                              return (
                                <div
                                  key={`${item?.id || item?.name}-${index}`}
                                  className={`cluster-advert ${item?.isActual ? "cluster-advert-app" : "cluster-advert-directory"}`}
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    if (item?.isActual) {
                                      OnCardClickHandler(
                                        item?.id,
                                        item?.micrositeLogo,
                                        item?.name
                                      );
                                      return;
                                    }
                                    selectedOrg(item, true, currentBusinessCardPos);
                                  }}
                                >
                                  {item?.isActual ? (
                                    <div className="card-container">
                                      <div className="text-container">
                                        <span className="microsite-position text-bold">
                                          {item?.micrositeLogo ? (
                                            <img
                                              src={item.micrositeLogo}
                                              alt={item?.name || ""}
                                              className="preview-image"
                                            />
                                          ) : null}
                                        </span>
                                        <div className="sector-info-container">
                                          <span className="microsite-details text-bold">
                                            {item?.businessDescription || item?.name}
                                          </span>
                                        </div>
                                      </div>
                                      <div className="image-container">
                                        {renderMapAdvertMedia(item)}
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="cluster-advert-directory-body">
                                      <div className="name">{item?.name}</div>
                                      {item?.address ? <div>{item.address}</div> : null}
                                      {item?.phoneNumber ? (
                                        <div>Phone number: {item.phoneNumber}</div>
                                      ) : null}
                                      {item?.email ? <div>Email: {item.email}</div> : null}
                                    </div>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        );
                      })}
                    </div>
                  )}
                  {selectedMicrosite?.isActual && <div className="card-container">
                    <div className="text-container">
                      <span className="microsite-position text-bold">
                        <img
                          src={selectedMicrosite?.micrositeLogo}
                          alt={selectedMicrosite?.name}
                          className="preview-image"
                          // onClick={() => {
                          //   OnCardClickHandler(
                          //     selectedMicrosite?.id,
                          //     selectedMicrosite?.micrositeLogo,
                          //     selectedMicrosite?.name
                          //   );
                          // }}
                        />
                      </span>
                      <CloseOutlined
                        className="closeIcon"
                        onClick={(e) => {
                          e.stopPropagation()
                          setCardState(false);
                          setSelectedMicrosite({ closePopup: true });
                          selectedData({});
                          setCancelClick(true)
                        }}
                      />
                      <div
                        className="sector-info-container"
                        // onClick={() => {
                        //   OnCardClickHandler(
                        //     selectedMicrosite?.id,
                        //     selectedMicrosite?.micrositeLogo,
                        //     selectedMicrosite?.name
                        //   );
                        // }}
                      >
                        <span className="microsite-details text-bold">
                          {selectedMicrosite?.businessDescription}
                        </span>
                      </div>
                    </div>
                    <div className="image-container">
                      {selectedMicrosite?.carouselLink?.mediaType ===
                        "SOCIAL_MEDIA" && selectedMicrosite?.carouselLink?.url ? (
                        <>
                          <div
                            className="media youtube"
                            style={{ objectFit: "contain" }}
                            // onClick={() =>
                            //   PlayVideoHandler(
                            //     selectedMicrosite?.carouselLink?.url,
                            //     selectedMicrosite?.carouselLink?.mediaType
                            //   )
                            // }
                          >
                            {(() => {
                              const videoID = getYouTubeVideoId(selectedMicrosite.carouselLink?.url);
                              if (!videoID) return null;
                              return (
                                <>
                                  <img
                                    src={`https://img.youtube.com/vi/${videoID}/hqdefault.jpg`}
                                    // style={{ height: "90%", borderRadius: "8px" }}
                                    alt="video "
                                    className="video-preview-image"
                                  />
                                  <img
                                    alt='play button'
                                    className="ytBtnOverlay"
                                    src={ytPlayBtn}
                                    onClick={(e) =>
                                    {
                                      e.stopPropagation()
                                      PlayVideoHandler(
                                        `https://www.youtube.com/embed/${videoID}?autoplay=1&rel=0`,
                                        selectedMicrosite?.carouselLink?.mediaType
                                      )
                                    }
                                    }
                                  />
                                </>
                              );
                            })()}
                          </div>
                        </>
                      ) : selectedMicrosite?.carouselLink?.mediaType ===
                        "VIMEO_MEDIA" &&
                        selectedMicrosite?.carouselLink?.url ? (
                        <div
                          className="media vimeo youtube"
                          onClick={(e) => {
                            e.stopPropagation()
                            PlayVideoHandler(
                              selectedMicrosite?.carouselLink?.url,
                              selectedMicrosite?.carouselLink?.mediaType
                            );
                          }}
                        >
                          <img
                            alt="Vimeo preview"
                            src={`https://vumbnail.com/${selectedMicrosite?.carouselLink?.url?.split("/")[4]
                              }.jpg`}
                            className="video-preview-image"
                          // style={{ height: "90%", borderRadius: "8px" }}
                          />
                          <img className="ytBtnOverlay" src={ytPlayBtn} alt="" />
                        </div>
                      ) : selectedMicrosite.carouselLink?.mediaType ===
                        "SYNTHESIA_MEDIA" && selectedMicrosite.carouselLink?.url ? (
                        (() => {
                          const videoId = extractSynthesiaId(selectedMicrosite.carouselLink.url);
                          if (!videoId) return null;

                          return (
                            <div
                              className="media youtube"
                              style={{ objectFit: "contain" }}
                              onClick={(e) =>
                              {
                                e.stopPropagation()
                                PlayVideoHandler(
                                  `https://share.synthesia.io/embeds/videos/${videoId}?autoplay=1`,
                                  selectedMicrosite.carouselLink.mediaType
                                )
                              }
                              }
                            >
                              <img
                                src={selectedMicrosite?.carouselLink?.thumbnailUrl || SynthesiaImage}
                                alt="Synthesia Video"
                                className="video-preview-image"
                              />

                              <img
                                className="ytBtnOverlay"
                                src={ytPlayBtn}
                                alt="Play Button"
                              />
                            </div>
                          );

                        })()
                      ) : (
                        <div className="media">
                          <div className="slider-Img">
                            <img
                              src={selectedMicrosite?.carouselLink?.url}
                              alt=""
                              className="home-preview-img"

                            />
                          </div>
                        </div>
                      )}
                    </div>
                 
                  </div>}
                  {
                    !selectedMicrosite?.isActual && !selectedMicrosite?.isCluster &&
                    <div className="card-container org-directory-card">
                      <div className="d-flex flex-column text-center">
                        <div className="name">{selectedMicrosite?.name}</div>
                        <CloseOutlined
                          className="closeIcon"
                          onClick={(e) => {
                            e.stopPropagation()
                            setCardState(false);
                            setSelectedMicrosite({ closePopup: true });
                            selectedData({});
                            setCancelClick(true)
                          }}
                        />
                        <div>{selectedMicrosite?.address}</div>

                        {selectedMicrosite?.phoneNumber && <div>
                          <span>Phone number: </span>
                          <span>{selectedMicrosite?.phoneNumber || '--'}</span>
                        </div>}
                        {selectedMicrosite?.email && <div>
                          <span>Email: </span>
                          <span>{selectedMicrosite?.email}</span>
                        </div>}
                        <div>
                          {selectedMicrosite?.website && <><span>Website: </span>
                            <a
                              title={selectedMicrosite?.website}
                              href={selectedMicrosite.website}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: "#2563eb", textDecoration: "underline" }}
                            >
                              {selectedMicrosite.website?.slice(0, 70)}{selectedMicrosite?.website?.length > 70 ? '...' : ''}
                            </a></>}
                        </div>
                      </div>
                    </div>
                  }
                </Card>
              </div>
            ) : (
              <></>
            )}
          </motion.div>
          {isModalOpen ? (
            <ModalPlayer
              closeModal={handleCancel}
              mediaLink={videoUrl}
              mediaType={mediatype}
            />
          ) : (
            ""
          )}
        </Content>
      </Layout>
    );
  }
}
